import { Injectable } from '@angular/core';
import { Router, CanActivate, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { GlobalConfig } from '../entities/global-config';
import { AuthHttp, AuthConfig, JwtHelper } from 'angular2-jwt';
import { TokenService } from '../service/token.service';
import { debug } from 'util';

@Injectable()
export class AuthGuardComponent implements CanActivate, Resolve<boolean>  {

    constructor(private router: Router, private globalConfig: GlobalConfig, private tokService: TokenService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      if (this.tokService.isLogin()) {
            if (this.checkHavePermission(state.url)) {
                return true;
            } else {

                if (state.url === '/') {
                    return true;
                }
                this.router.navigate(['./un-authorized']);
                return false;
            }
        }

        this.router.navigate(['login']);
        return false;
    }

    checkHavePermission(url) {
        const arrOfStr = url.split('/');
        const permissions = this.tokService.getPermissioin();
        var index = permissions.indexOf('/' + arrOfStr[1]) !== -1;
        return index;
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.tokService.isLogin()) {
            this.router.navigate(['']);
            return false;
        }
        return true;
    }
}




// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/service/auth.guard.component.ts